import { useEffect, useState } from 'react'
import Modal from 'react-modal'
import { ButtonCmp } from '../../../../../../components/ButtonCmp'
import { InputCmp } from '../../../../../../components/InputCmp'
import { ModalBody, ModalContent, ModalFooter } from './styles'

Modal.setAppElement('#root')

interface ISquadModalProps {
  isOpen: boolean
  titulo: string
  nomeInicial?: string
  onRequestClose: () => void
  onConfirm: (nome: string) => void
}

export const SquadModal: React.FC<ISquadModalProps> = ({
  isOpen,
  titulo,
  nomeInicial,
  onRequestClose,
  onConfirm
}) => {
  const [Nome, setNome] = useState('')

  useEffect(() => {
    setNome(nomeInicial ?? '')
  }, [nomeInicial, isOpen])

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      overlayClassName="react-modal-overlay"
      className="react-modal-content-default"
    >
      <ModalContent>
        <h3>{titulo}</h3>
        <ModalBody>
          <InputCmp
            mt={'.5rem'}
            OnChange={setNome}
            placeholder='Digite um nome'
            value={Nome}
          />
        </ModalBody>
        <ModalFooter>
          <ButtonCmp VarColor='c6' onClick={onRequestClose}>Fechar</ButtonCmp>
          <ButtonCmp VarColor='Green2' onClick={() => onConfirm(Nome)}>Salvar</ButtonCmp>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
